<template>
  <lf-content-loader :is-loading="runScorecardIds.includes(model.id)">
    <lf-pill
      v-if="!!model.results?.length"
      scorecard
      :size="statusContent.size"
      :color-index="statusContent.colorIndex"
      class="h-6 font-semibold"
    >
      <span v-tooltip="toolTipContent" class="max-w-30 min-w-20 truncate">
        {{ statusContent.name }}
      </span>
    </lf-pill>
  </lf-content-loader>
</template>

<script setup lang="ts">
import { computed } from "vue";

import {
  getColorId,
  getGroupResults,
  getResults,
  modelIsScorecardGroup,
} from "@/helpers/scorecards";
import { useScorecardsBase } from "@/hooks/scorecards";

import LfContentLoader from "@/components/ui/LfContentLoader.vue";

import type { IScorecard, IScorecardGroup } from "@/models/scorecards";

const { runScorecardIds } = useScorecardsBase();

const props = defineProps<{
  model: IScorecard | IScorecardGroup;
}>();

const CHAR_LIMIT_SHOW_TOOLTIP = 15;

const statusContent = computed(() => {
  if (modelIsScorecardGroup(props.model)) {
    return {
      colorIndex: getColorId(
        getGroupResults(props.model)[0]?.score_card_group_status?.color || ""
      ),
      name:
        getGroupResults(props.model)[0]?.score_card_group_status?.name || "-",
      size: "md",
    };
  }

  return {
    colorIndex: getColorId(
      getResults(props.model)[0]?.score_card_status?.color || ""
    ),
    name: getResults(props.model)[0]?.score_card_status?.name || "-",
    size: "sm",
  };
});

const toolTipContent = computed(() =>
  statusContent.value.name.length > CHAR_LIMIT_SHOW_TOOLTIP
    ? statusContent.value.name
    : undefined
);
</script>
